/* eslint-disable max-len */

import { Component, ElementRef, OnInit, ViewChild, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';
import { C3Service } from '../../c3.service';
import { ModelService } from '../../model.service';
import { ContextMenuItem } from '../context-menu/context-menu.component';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ProgressTask {
  id: number;
  progess: number;
  alive: boolean;
  streamingStatus: StreamingStatus;
  streamingState: number;
}

export enum StreamingStatus {
  LOADING_GEOMETRY = 'loading geometry',
  ISO_VOLUME = 'loading iso volume',
  ISO_RANGES = 'loading iso ranges',
}

@Component({
    selector: 'ceetron-viewer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './viewer.component.html',
    styleUrls: ['./viewer.component.css'],
    standalone: false
})
export class ViewerComponent implements OnInit, OnDestroy {
  @Input('modelId') modelId: string = '0';

  public contextMenuItems: ContextMenuItem[] = [
    // { text: 'Show all parts', execute: () => this._c3Service.showAllParts() },
    // { text: '--', execute: () => this._c3Service.dummy() },
    // {
    //   text: 'Show all parts as Surface',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE),
    // },
    // {
    //   text: 'Show all parts as Surface Mesh',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE_MESH),
    // },
    // {
    //   text: 'Show all parts as Surface Mesh Outline',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE_OUTLINE_MESH),
    // },
    // {
    //   text: 'Show all parts as Transparent Surface',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.SURFACE, 0.5),
    // },
    // {
    //   text: 'Show all parts as Lines',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.LINES),
    // },
    // {
    //   text: 'Show all parts as Points',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.POINTS),
    // },
    // {
    //   text: 'Show all parts as Outline',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.OUTLINE),
    // },
    // {
    //   text: 'Show all parts as Hidden Lines',
    //   execute: () => this._c3Service.setDrawStyleAllParts(cee.ug.DrawStyle.HIDDEN_LINES_REMOVED),
    // },
    // { text: '--', execute: () => this._c3Service.dummy() },
    {
      text: 'Pan',
      execute: () => {
        this.c3Service._view[this.modelId].navigation.config.leftMouseButton.noModifier = cee.NavigationType.PAN;
        this.snackBar.open('Enabled pan mode...', 'OK', { duration: 2000 });
      },
    },
    {
      text: 'Rotate',
      execute: () => {
        this.c3Service._view[this.modelId].navigation.config.leftMouseButton.noModifier = cee.NavigationType.ROTATE;
        this.snackBar.open('Enabled rotation mode...', 'OK', { duration: 2000 });
      },
    },
    {
      text: 'Set rotation point...',
      execute: () => {
        this.snackBar.open('Please select a new rotation point with left mouse click...', 'OK', { duration: 2000 });
        const sub = this.c3Service.elementPicked[this.modelId].subscribe((hitItem: any) => {
          this._c3Service._view[this.modelId].navigation.rotationPoint = hitItem.intersectionPoint;
          sub.unsubscribe();
          this.snackBar.open('New rotation point set...', 'OK', { duration: 2000 });
        });
      },
    },
    // {
    //   text: 'Open model...',
    //   execute: () => this._modelService.showModelList(),
    // },
  ];

  @ViewChild('container', { static: true }) _containerRef!: ElementRef;
  @ViewChild('canvas', { static: true }) _canvasRef!: ElementRef;

  private _c3Service: C3Service;
  private _modelService: ModelService;
  private elementPicked: boolean = false;

  // public get currentProgress() {

  //     const task = this._modelService.progress.filter(x => x.id == parseInt(this.modelId))[0];

  //     if(task) {
  //         return task.progess;
  //     }

  //     return 0;

  // }

  // public get isTaskAlive() {

  //     const task = this._modelService.progress.filter(x => x.id == parseInt(this.modelId))[0];

  //     if(task) {
  //         return task.alive;
  //     }

  //     return false;
  // }

  // public get currentStreamingStatus() {

  //     const task = this._modelService.progress.filter(x => x.id == parseInt(this.modelId))[0];

  //     if(task) {
  //         return task.streamingStatus + '...';
  //     }

  //     return '';
  // }

  public constructor(
    private c3Service: C3Service,
    modelService: ModelService,
    private host: ElementRef<HTMLElement>,
    private cd: ChangeDetectorRef,
    private snackBar: MatSnackBar
  ) {
    this._c3Service = c3Service;
    this._modelService = modelService;
  }

  public ngOnInit() {
    // this._c3Service.initialize(this._canvasRef, this._containerRef);
    // this._modelService.openModel();
  }

  ngAfterViewInit() {
    const canId = 'can' + this.modelId;
    const contId = 'cont' + this.modelId;
    const can = document.getElementById(canId);
    const cont = document.getElementById(contId);

    if (can && cont) {
      this._c3Service.initialize(can, cont, this.modelId);
    }

    // this.cd.detach();

    // setInterval(() => {
    //     this.cd.detectChanges();
    // }, 50000);
  }

  ngOnDestroy(): void {
    this.host.nativeElement.remove();
  }

  // public stop() {
  //     console.log('called detach');
  //     this.cd.detach();
  // }
}
